module.exports = __webpack_public_path__ + "img/6.31462b0c.png";